import { Colors, LineArt } from "../../config/DesignConstants";
import BaseEntity from "../../core/entity/BaseEntity";
import { GameEvents } from "../../core/entity/Entity";
import { createGraphics, GameGraphics } from "../../core/entity/GameSprite";

const CROSSHAIR_SIZE = 24;
const CROSSHAIR_GAP = 8;
const CENTER_DOT_SIZE = 2;
const CENTER_RING_SIZE = 8;

export class GameCursor extends BaseEntity {
  pausable = false; // Cursor should work even when game is paused
  sprite: GameGraphics;

  constructor() {
    super();

    // Create graphics for the crosshair
    this.sprite = createGraphics("cursor");
    this.drawCrosshair();
  }

  onAdd({ game }: GameEvents["add"]): void {
    game.renderer.hideCursor();
  }

  onTick(): void {
    // Position the cursor at the current mouse position (screen coordinates)
    const mousePos = this.game!.io.mousePosition;
    this.sprite.position.set(mousePos.x, mousePos.y);
  }

  private drawCrosshair(): void {
    this.sprite.clear();

    // Main crosshair lines with gaps
    // Top line
    this.sprite
      .moveTo(0, -CROSSHAIR_SIZE)
      .lineTo(0, -CROSSHAIR_GAP)
      .stroke({ color: Colors.CYAN, width: LineArt.LINE_WIDTH.STANDARD });

    // Bottom line
    this.sprite
      .moveTo(0, CROSSHAIR_GAP)
      .lineTo(0, CROSSHAIR_SIZE)
      .stroke({ color: Colors.CYAN, width: LineArt.LINE_WIDTH.STANDARD });

    // Left line
    this.sprite
      .moveTo(-CROSSHAIR_SIZE, 0)
      .lineTo(-CROSSHAIR_GAP, 0)
      .stroke({ color: Colors.CYAN, width: LineArt.LINE_WIDTH.STANDARD });

    // Right line
    this.sprite
      .moveTo(CROSSHAIR_GAP, 0)
      .lineTo(CROSSHAIR_SIZE, 0)
      .stroke({ color: Colors.CYAN, width: LineArt.LINE_WIDTH.STANDARD });

    // Center elements
    // Outer ring (scaled up)
    this.sprite
      .circle(0, 0, CENTER_RING_SIZE)
      .stroke({ color: Colors.CYAN, width: LineArt.LINE_WIDTH.STANDARD });

    // Center dot
    this.sprite.circle(0, 0, CENTER_DOT_SIZE).fill({ color: Colors.CYAN });
  }
}
